import { useNavigate } from "react-router-dom";
import { useAppState } from "../store/contextProvider";
import { AppActions } from "../store/reducers";

export const useINavigation = () => {
  const navigate = useNavigate();
  const { updateStore, pageState } = useAppState();

  const navigateTo = (pageName) => {
    navigate(`/${pageName}`);
    updateStore({
      type: AppActions.updatePageState,
      payload: { selectedPage: pageName },
    });
  };

  const getPageTitle = () => pageState?.selectedPage || "Dashboard";

  return { navigateTo, getPageTitle };
};
